
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import { getVymeraStringWithUnitHa } from '../../common/common/iskn/vymera';
import Text from '../../common/client/components/Text';

import listGetActions from '../../sagas/list';
import ObjectInfoTitle from './ObjectInfoTitle';
import ObjectInfoValues from './ObjectInfoValues';

const classNames = mergeStyleSets({
    root: {
        borderBottom: '1px solid #dddddd',
        paddingBottom: 8
    }
});

const ObjectInfoListParcel = (props) => {
    const dispatch = useDispatch();
    const listActions = listGetActions(dispatch);

    const token = useSelector(state => {
        return state.auth.data ? state.auth.data.user.token : null;
    });

    const projectId = useSelector(state => {
        return state.project.data.project.id;
    });

    const list = useSelector(state => {
        return state.list;
    });

    useEffect(() => {
        if (!list.loaded && !list.loading) {
            listActions.listGet(token, projectId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div className={classNames.root}>
            <Stack>
                <Stack.Item>
                    <ObjectInfoTitle title="SEZNAM PARCEL" />
                </Stack.Item>
                <Stack.Item>
                    {list.actualList
                        ? <Stack horizontal>
                            <Stack.Item grow>
                                <ObjectInfoValues
                                    items={[
                                        {
                                            title: 'Aktuální seznam parcel',
                                            value: `${list.actualList.title}`
                                        },
                                        {
                                            title: 'Počet parcel',
                                            value: `${list.actualList.count}`
                                        },
                                        {
                                            title: 'Výměra parcel',
                                            value: getVymeraStringWithUnitHa(parseInt(list.actualList.vymera))
                                        }
                                    ]}
                                />
                            </Stack.Item>
                        </Stack>
                        : <Text>Načítám data...</Text>
                    }
                </Stack.Item>
            </Stack>
        </div>
    );
}

export default ObjectInfoListParcel;
